<div *ngIf="data?.value as value">
    <div class="value-info"><h2 class="m-0">{{value.name}}</h2></div>
    <h3>Meaning of the value</h3>
    <adapt-html-editor [(contents)]="value.meaning"
                       forceSize="compact"
                       (isValidChange)="isEditorValid = $event; validateEntities()"
                       data-test="value-meaning-input"></adapt-html-editor>
</div>
